var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.bottomImg),expression:"bottomImg"}],staticClass:"bottomImg",attrs:{"alt":""},on:{"click":function($event){return _vm.openDown()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }